type NameSortValue = { name?: string | null } | null | undefined;

/**
 * AG Grid comparator for the Impact Reports Name column.
 * The column valueGetter returns an object for UseCaseNameCellRenderer, so default sort cannot compare names.
 */
export function compareImpactReportNames(valueA: NameSortValue, valueB: NameSortValue): number {
  return (valueA?.name ?? '').localeCompare(valueB?.name ?? '');
}
